import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import { workplaceHealthPromotion } from 'assets/img/index'
import { Grid } from 'components/atoms'
import { arrayOf, shape, string, number } from 'prop-types'
import * as Styled from './WorkplaceHealthPromotion.styles'

const WorkplaceHealthPromotion = ({ items }) => {
  const textContext = useContext(TextContext)
  const { PIP_SEAL } = workplaceHealthPromotion

  const getImage = (type) => {
    switch (type) {
      case 'PIP':
        return PIP_SEAL
      default:
        return ''
    }
  }

  return (
    <Styled.WorkplaceHealthPromotion>
      {items.length > 0 &&
        items.map((item) => (
          <Grid
            container
            data-cy-health-promotion={ item.type }
            key={ item.id }
            className={ 'grid' }>
            <Grid item xs={ 12 } sm={ 8 } print={ 8 }>
              <p
                className={ item.type }
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </Grid>
            <Grid item xs={ 12 } sm={ 4 } print={ 4 }>
              <img
                src={ getImage(item.type) }
                alt={
                  textContext[`workplaceHealthPromotion.images.${ item.type }`]
                }
                className={ item.type }
              />
            </Grid>
          </Grid>
        ))}
    </Styled.WorkplaceHealthPromotion>
  )
}

WorkplaceHealthPromotion.propTypes = {
  items: arrayOf(
    shape({
      type: string.isRequired,
      id: number.isRequired,
      description: string.isRequired,
    })
  ).isRequired,
}

export default WorkplaceHealthPromotion
